module.exports = __webpack_public_path__ + "img/top-box-classic.02e552f6.png";